import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { additionalFeedback } from '../../models/feedbackResponse';
import { SnackBarService } from '../../services/snack-bar.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-feedback-detail',
  standalone: true,
  imports: [
    MatIconModule,
    FormsModule,
    CommonModule
  ],
  templateUrl: './feedback-detail.component.html',
  styleUrl: './feedback-detail.component.scss'
})
export class FeedbackDetailComponent {

  index = 0; 
  // additional feedback reason
  feedbackReason = '';
  // feedback reason options
  feedbackReasonOptions:string[]  = ['Irrelevant', 'Incorrect', 'Unsafe'];
  // selected reason
  @Input() feedbackReasonText = '';
  // response id
  @Input() responseId = '';
  // unique conversation id
  @Input() uniqueConversationId = '';
  // feedback
  @Input() feedback = '';
  // close event for feedback
  @Output() sendCloseEvent = new EventEmitter<boolean>();
  // submit event for feedback
  @Output() submitFeedbackEvent = new EventEmitter<additionalFeedback>();

  constructor(private snackBarService:SnackBarService, private chatService:ChatService){}

  closeFeedbackDetail(){
    this.sendCloseEvent.emit(false)
  }

  submitFeedback(){
    if(this.feedbackReasonText.trim()){
      // removing the special characters from text
      this.feedbackReasonText = this.feedbackReasonText.replace(/[^a-zA-Z0-9\s/,]/g, '');;
      // trim the text for any spaces
      this.feedbackReasonText = this.feedbackReasonText.trim();
      if(this.feedbackReasonText.length === 0){
        this.snackBarService.openSnackBar("Please do not enter special characters or empty string", "Dismiss", 5000);
        return;
      }
      this.closeFeedbackDetail();
      this.postFeedback(this.responseId, this.feedback, this.feedbackReason, this.feedbackReasonText);
    }
  }

  postFeedback(responseId: string, feedback: string, feedbackReason?: string, feedbackReasonText?: string){
    this.chatService.feedback(responseId, this.uniqueConversationId,feedback, feedbackReason,feedbackReasonText).subscribe({
      next: () => {  
        // success message if any
      },
      error: (error) => {
        this.snackBarService.showErrorMessage(error.error.statusCode);
      }
    });
  }

  selectOption(option:string){
    if(this.feedbackReason === option){
      this.feedbackReason = '';
    } else {
      this.feedbackReason = option;
    }
  }

}
